<div style="overflow:hidden" *ngFor="let notice of notices"
	@flyInOut
	(@flyInOut.start)="noticeAnimationStarted($event)"
	(@flyInOut.done)="noticeAnimationDone($event)">
	<ta-growl-notice [notice]="notice"></ta-growl-notice>
</div>
